export default "__VITE_ASSET__82097849__"